import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ChangePasswordRequest } from '../../models/auth-basic';
import { PASS_PATERN } from '@t-llevo/util';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'auth-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ChangePasswordComponent {
  @Input() showAction = true;
  @Output() changePassword: EventEmitter<ChangePasswordRequest> =
    new EventEmitter();
  frm = this.fb.group(
    {
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.pattern(PASS_PATERN)]],
      confirmNewPassword: ['', [Validators.required]],
    },
    { validators: [this.createPasswordValidator()] }
  );

  hidenNewPass = true;
  hidenCurrentPass = true;
  hidenConfirmPass = true;
  constructor(public fb: FormBuilder) {}

  save(): void {
    if (this.frm.invalid) {
      return;
    }
    this.changePassword.emit({
      userId: '',
      old_password: this.oldPass.value ?? '',
      password: this.newPass.value ?? '',
      password2: this.confirmPass.value ?? '',
    });
  }

  confirm_pass(): boolean | undefined {
    return (
      this.frm.hasError('noEqualsPassword') &&
      this.frm.get('confirmNewPassword')?.dirty &&
      this.frm.get('confirmNewPassword')?.dirty
    );
  }

  createPasswordValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const newPassword = form.get('newPassword')?.value;
      const confirmNewPassword = form.get('confirmNewPassword')?.value;
      return newPassword === confirmNewPassword
        ? null
        : {
            noEqualsPassword: true,
          };
    };
  }

  get oldPass() {
    return this.frm.controls['oldPassword'];
  }

  get newPass() {
    return this.frm.controls['newPassword'];
  }

  get confirmPass() {
    return this.frm.controls['confirmNewPassword'];
  }
}
